export const SET_CLEANER = "SET_CLEANER";
export const UPDATE_CLEANING_REQUEST = "UPDATE_CLEANING_REQUEST";
export const UPDATE_CLEANING_SUCCESS = "UPDATE_CLEANING_SUCCESS";
export const UPDATE_CLEANING_REJECT = "UPDATE_CLEANING_REJECT";
export const CREATE_CLEANING_REQUEST = "CREATE_CLEANING_REQUEST";
export const CREATE_CLEANING_SUCCESS = "CREATE_CLEANING_SUCCESS";
export const CREATE_CLEANING_REJECT = "CREATE_CLEANING_REJECT";
export const LOAD_FRESH = "LOAD_FRESH";
export const LOAD_CLEANING_ID = "LOAD_CLEANING_ID";



// WEBPACK FOOTER //
// ./src/cleaning/schedule/constants.js